import type { FlagCreationSuggestionMutationFn } from '@gonfalon/observability-graphql/hooks';
import type { AgentPromptMutationFn } from '@gonfalon/vega/components/AgentInsights/AgentInsights';

/**
 * Adapts a `flag_creation_suggestion` mutation function to the
 * `agentPromptMutation` shape that `AgentInsightsPanel` expects. Both mutations
 * resolve to an `AgentMessage` payload, so this re-keys
 * `flag_creation_suggestion` → `agentPrompt` and forwards everything else
 * (errors, extensions, etc.) untouched. Mirrors `createPricingConciergeAdapter`.
 */
export function createFlagCreationSuggestionAdapter(
  flagCreationSuggestionMutation: FlagCreationSuggestionMutationFn,
): AgentPromptMutationFn {
  return async (options) => {
    const input = options?.variables?.input;
    const result = await flagCreationSuggestionMutation({
      variables: {
        input: {
          prompt: input?.prompt ?? '',
          conversation_id: input?.conversation_id,
          project_id: input?.project_id ?? '',
        },
      },
    });
    return {
      ...result,
      data: result.data
        ? { __typename: 'Mutation' as const, agentPrompt: result.data.flag_creation_suggestion }
        : result.data,
    };
  };
}
